import React from "react";
import DashboardNavbar from "../components/DashboardNavbar";
import DoctorManager from "../components/admin/DoctorManager";
import PatientManager from "../components/admin/PatientManager";
import SymptomManager from "../components/admin/SymptomManager";
import EnquireManager from "../components/admin/EnquireManager";


export default function AdminDashboard() {
  const [tab, setTab] = React.useState(0);
  const tabs = [
    { label: "Doctors", component: <DoctorManager /> },
    { label: "Patients", component: <PatientManager /> },
    { label: "Symptoms", component: <SymptomManager /> },
    { label: "Enquire", component: <EnquireManager /> }
  ];
  return (
    <div className="container py-5">
      <DashboardNavbar />
      <h2 className="mb-4">Admin Dashboard</h2>
      <ul className="nav nav-tabs mb-3" role="tablist">
        {tabs.map((t, i) => (
          <li className="nav-item" key={t.label}>
            <button
              className={`nav-link${tab === i ? " active" : ""}`}
              onClick={() => setTab(i)}
              type="button"
              role="tab"
            >
              {t.label}
            </button>
          </li>
        ))}
      </ul>
      <div className="card p-4">
        {tabs[tab].component}
      </div>
    </div>
  );
}
